// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Pg7","label":"styles_label__kLWWw"};